import React, { useRef, useEffect, useState } from "react";
import {
  Box,
  Typography,
  IconButton,
  ImageListItem,
  Stack,
  Grid,
} from "@mui/material";
import customOne from "./assets/custom/custom_1.png";
import customTwo from "./assets/custom/custom_2.png";
import customThree from "./assets/custom/custom_3.png";
import customFour from "./assets/custom/custom_4.png";
import customFive from "./assets/custom/custom_5.png";
import customSix from "./assets/custom/custom_6.jpg";
import customSeven from "./assets/custom/custom_7.jpg";
import customEight from "./assets/custom/custom_8.png";
import SAS from "./assets/custom/SAS_PRODUCT.png";
import AR_VR from "./assets/custom/ARANDVRPRODUCT.png";
import ConnectedProduction from "./assets/custom/CONNECTED_PRODUCT.png";
import AIProduct from "./assets/custom/AI_PRODUCT.png";

import { Divider } from "@mui/material";
import { useLocation } from "react-router-dom";

import {
  ChevronLeft,
  ChevronRight,
  FiberManualRecord,
} from "@mui/icons-material";
import Footer from "./footer";

const SoftWareSolution = () => {
  const scrollRef = useRef();
  const { pathname } = useLocation();

  const images = [customTwo, customThree, customFour, customSix, customEight];

  const indexRef = useRef(0);
  const [activeIndex, setActiveIndex] = useState(0);

  const scrollToIndex = (index) => {
    const width = scrollRef.current.offsetWidth;
    scrollRef.current.scrollTo({
      left: index * width,
      behavior: "smooth",
    });
    setActiveIndex(index);
  };

  const handleManualScroll = (direction) => {
    const newIndex =
      (indexRef.current + direction + images.length) % images.length;
    indexRef.current = newIndex;
    scrollToIndex(newIndex);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  useEffect(() => {
    const interval = setInterval(() => {
      indexRef.current = (indexRef.current + 1) % images.length;
      scrollToIndex(indexRef.current);
    }, 3000); // every 3 seconds

    return () => clearInterval(interval); // cleanup on unmount
  }, []);

  return (
    <Box>
      <Box maxWidth="100%">
        <Box
          sx={{
            position: "relative",
            minHeight: { xs: "50vh", md: "50vh" },
            backgroundImage: `url(${customOne})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            px: 2,
            flexDirection: "column",
            textAlign: "center",
            overflow: "hidden",
          }}
        >
          {/* Blurred Overlay */}
          <Box
            sx={{
              position: "absolute",
              inset: 0,
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              backdropFilter: "blur(2px)",
              zIndex: 1,
            }}
          />

          {/* Text Content */}
          <Box sx={{ maxWidth: "auto", mb: 4, zIndex: 2 }}>
            <Typography
              variant="h3"
              gutterBottom
              sx={{ color: "white", fontWeight: 700 }}
            >
              Software Solutions
            </Typography>
          </Box>
        </Box>
      </Box>

      <Grid
        container
        spacing={4}
        alignItems="top"
        justifyContent="center"
        sx={{ flexWrap: "wrap", mt: 5 }}
      >
        {/* Left: Image */}

        <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
          <Box
            sx={{
              pl: { xs: 2, md: 0 },
              pr: { xs: 2, md: 0 },
              mb: { xs: 0, md: 2 },
            }}
          >
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                color: "orange",
                textAlign: "left",
                pb: { xs: 2, md: 2 },
              }}
            >
              Custom Software Products
            </Typography>
            <Typography variant="body1" paragraph>
              Custom software products are tailored solutions designed to meet
              the specific needs of a business or organization. Unlike
              off-the-shelf software, these products are built from the ground
              up to align perfectly with workflows, objectives, and user
              preferences. This approach ensures that businesses enjoy a higher
              level of efficiency, flexibility, and scalability in their
              operations. With custom software, you gain complete control over
              the functionality, user experience, and integration capabilities.
              This enables seamless compatibility with existing systems and
              future upgrades.
            </Typography>
            <Typography variant="body1" paragraph>
              Whether it’s an internal tool or a customer-facing platform,
              custom software solutions give businesses a competitive edge by
              addressing their unique challenges directly.
            </Typography>

            <Typography variant="body1" paragraph>
              In today’s fast-paced digital environment, off-the-shelf solutions
              often fall short of meeting evolving business requirements. Custom
              software development allows companies to adapt quickly to market
              changes, incorporate specific security protocols, and maintain
              full ownership over their code and data. This level of
              customization not only reduces long-term operational bottlenecks
              but also cuts down on licensing fees and third-party dependencies.
              Moreover, custom software can be continuously updated and scaled
              as your business grows, ensuring it remains relevant and valuable
              over time. At our company, we specialize in building custom
              software products across various domains, including finance,
              healthcare, education, logistics, and retail. Our development
              process begins with a deep understanding of your goals and user
              needs, followed by agile-based execution that prioritizes
              performance and usability. From prototype to deployment and
              ongoing support, we ensure that each solution we deliver helps
              improve efficiency, drive engagement, and fuel digital
              transformation.
            </Typography>
          </Box>
        </Grid>

        <Grid item sx={{ width: { xs: "100%", md: "35%" } }}>
          <Box
            flex={1}
            maxHeight="800px"
            overflow="auto"
            borderLeft="1px solid #ccc"
            sx={{ pl: { xs: 0, md: 2 } }}
          >
            <Box>
              <Box
                display="flex"
                alignItems="center"
                justifyContent="center"
                sx={{
                  maxWidth: "100%",
                  mx: "auto",
                  overflow: "hidden",
                  mt: { xs: 0, md: 4 },
                }}
              >
                <IconButton onClick={() => handleManualScroll(-1)}>
                  <ChevronLeft />
                </IconButton>

                <Box
                  ref={scrollRef}
                  sx={{
                    width: { xs: "100%", md: 600 },
                    height: { xs: "100%", md: 500 },
                    display: "flex",
                    overflowX: "hidden",
                    scrollSnapType: "x mandatory",
                  }}
                >
                  {images.map((src, index) => (
                    <ImageListItem
                      key={index}
                      sx={{
                        flex: "0 0 100%",
                        scrollSnapAlign: "center",
                      }}
                    >
                      <img
                        src={src}
                        alt={`Slide ${index + 1}`}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                          borderRadius: "16px", // Adjust as needed (e.g., 8px, 24px)
                        }}
                        loading="lazy"
                      />
                    </ImageListItem>
                  ))}
                </Box>

                <IconButton onClick={() => handleManualScroll(1)}>
                  <ChevronRight />
                </IconButton>
              </Box>

              {/* Indicators */}
              <Stack
                direction="row"
                justifyContent="center"
                mt={2}
                sx={{ mt: 5 }}
              >
                {images.map((_, index) => (
                  <IconButton
                    key={index}
                    size="small"
                    onClick={() => scrollToIndex(index)}
                  >
                    <FiberManualRecord
                      fontSize="small"
                      color={index === activeIndex ? "primary" : "disabled"}
                    />
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 1, borderColor: "orange", mt: 5 }} />

      <Box sx={{ width: { xs: "100%", md: "80%" }, mx: "auto", mb: 5 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            px: 2,
            mt: 5,
          }}
        >
          <Box>
            <Typography
              variant="h4"
              sx={{ color: "orange", fontWeight: "bold", mb: 1 }}
            >
              Our Software Solutions
            </Typography>

            <Typography variant="body1" sx={{ mb: 2 }}>
              Our software solutions are crafted with innovation, precision, and
              user-centric design at their core. From enterprise platforms to
              mobile and web applications, we ensure every solution is scalable,
              secure, and reliable. We combine industry best practices with
              emerging technologies to deliver performance-driven software that
              accelerates growth. We engage closely with our clients at every
              stage—from discovery to deployment—to ensure the software meets
              business goals while exceeding user expectations. Our team focuses
              on quality, agility, and continuous improvement, enabling us to
              deliver solutions that evolve with your business.
            </Typography>
          </Box>
        </Box>

        {/* Centered small orange line */}
        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        {/* Content Block: Image Left, Text Right */}
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={customSeven}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Custom Software
            </Typography>
            <Typography variant="body1">
              Custom software development gives businesses the opportunity to
              solve specific operational needs that off-the-shelf products
              cannot address. Whether it’s a customer management tool, internal
              dashboard, or automation suite, custom-built software enhances
              productivity and aligns with your business model precisely. We
              specialize in understanding complex requirements and translating
              them into functional, user-friendly applications. Our custom
              software development process involves rigorous analysis,
              collaborative design, and robust implementation to create
              dependable systems that serve real-world objectives. Custom
              software is not just about building an application — it’s about
              creating a long-term digital asset tailored to your exact
              operational landscape. It offers the freedom to innovate without
              the constraints of generic solutions. With our expertise, we
              ensure seamless integration with your existing infrastructure,
              advanced security protocols, and performance optimization for
              maximum efficiency. You benefit from a solution that evolves
              alongside your business, ensuring relevance, agility, and growth
              over time.
            </Typography>
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />
        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{ flexWrap: "wrap", pl: { xs: 2, md: 0 }, pr: { xs: 2, md: 0 } }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Digital Products
            </Typography>
            <Typography variant="body1">
              Digital products such as mobile apps, web platforms, and online
              tools form the backbone of modern digital strategies. These
              products are designed to deliver value directly to users, helping
              businesses reach wider audiences and engage customers more
              effectively. Our expertise in digital product development spans
              industries and use cases—from e-learning platforms to e-commerce
              applications. We design, build, and support digital experiences
              that are not only visually appealing but also intuitive and
              result-oriented.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={customFive}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Divider
          sx={{
            width: 60,
            mx: "auto",
            borderBottom: "3px solid orange",
            mb: 4,
          }}
        />

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            pb: { xs: 2, md: 0 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}
          <Grid item sx={{ width: { xs: "100%", md: "40%" } }}>
            <img
              src={AR_VR}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          {/* Right: Text */}
          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              AR and VR Products
            </Typography>
            <Typography variant="body1">
              Augmented Reality (AR) and Virtual Reality (VR) are reshaping how
              users interact with digital environments. These immersive
              technologies offer cutting-edge experiences for training,
              marketing, gaming, education, and more, bridging the gap between
              the digital and physical worlds. Our team develops tailored AR and
              VR solutions that captivate audiences and provide real-time value.
              Whether it’s a product showcase, a virtual walkthrough, or a
              simulation training module, our AR/VR products enhance engagement
              and deliver innovative experiences to your end users. level of
              quality and customization to meet your specific business goals.
              Beyond entertainment and marketing, AR and VR solutions play a
              crucial role in training and simulation by offering safe,
              cost-effective, and highly realistic environments. We work closely
              with you to design applications that not only captivate users but
              also improve learning outcomes, increase operational efficiency,
              and reduce risks. From concept development to deployment, our team
              leverages the latest hardware and software tools to deliver
              scalable, customizable AR/VR products that push the boundaries of
              technology and creativity.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",
                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              SaaS Software
            </Typography>
            <Typography variant="body1">
              Software as a Service (SaaS) products are cloud-based applications
              accessible via a subscription model. They provide flexibility,
              cost-effectiveness, and minimal setup, making them ideal for
              businesses of all sizes. From CRM tools to project management
              platforms, SaaS is transforming software delivery. We specialize
              in building secure, scalable, and multi-tenant SaaS platforms with
              modern user interfaces and powerful backend infrastructure. Our
              SaaS solutions are easy to maintain, quick to deploy, and highly
              customizable, giving clients a competitive advantage in their
              respective markets.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={SAS}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={ConnectedProduction}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              Connected Products
            </Typography>
            <Typography variant="body1">
              Connected products use IoT (Internet of Things) technology to
              provide real-time monitoring, control, and data analytics. These
              smart devices are revolutionizing sectors like healthcare,
              manufacturing, agriculture, and consumer electronics. We build
              connected solutions that combine hardware integration, cloud
              connectivity, and responsive applications. From smart sensors to
              data dashboards, our connected product offerings help businesses
              optimize operations and gain insights from devices spread across
              the globe.
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          spacing={4}
          alignItems="center"
          justifyContent="center"
          sx={{
            flexWrap: "wrap",
            mt: { xs: 0, md: 5 },
            pl: { xs: 2, md: 0 },
            pr: { xs: 2, md: 0 },
          }}
        >
          {/* Left: Image */}

          <Grid item sx={{ width: { xs: "100%", md: "55%" } }}>
            <Typography
              variant="h5"
              sx={{
                fontWeight: "bold",

                mb: 2,
                color: "orange",
                textAlign: "left",
              }}
            >
              AI Products
            </Typography>
            <Typography variant="body1">
              Artificial Intelligence (AI) is powering the next generation of
              intelligent software products. From chatbots and recommendation
              engines to predictive analytics and process automation, AI is
              enabling businesses to operate smarter and more efficiently. We
              design AI-powered products that solve complex problems using
              machine learning, natural language processing, and data science.
              Our AI solutions are tailored to help clients make data-driven
              decisions, enhance customer experience, and streamline their
              business workflows.
            </Typography>
          </Grid>

          <Grid item sx={{ width: { xs: "100%", md: "25%" } }}>
            <img
              src={AIProduct}
              alt="Years of experience"
              style={{ width: "100%", borderRadius: "12px" }}
            />
          </Grid>
        </Grid>
      </Box>
      <Footer />
    </Box>
  );
};

export default SoftWareSolution;
